import { Input, Space, Button, Form, Select, Alert } from "antd";
import i18next from "i18next";
import { useState } from "react";

import ProjectParameters from "@arcgis/core/rest/support/ProjectParameters.js";
import Point from "@arcgis/core/geometry/Point.js";
import { project } from "@arcgis/core/rest/geometryService.js";


const { Option } = Select;

const SearchCoordinatesComponent = ({ setCoordenadas }) => {

    const [showAlert, setShowAlert] = useState(false);
    const [form] = Form.useForm();
    const [tipoCoordenadas, setTipoCoordenadas] = useState("WGS84 H30");

    const formItemLayout = { labelCol: { span: 8 }, wrapperCol: { span: 14 } };

    const buttonItemLayout = {
        wrapperCol: { span: 14, offset: 4 }
    };

    /**
     * Función que comprueba que los valores introducidos en los input son coordenadas válidas.
     * 
     * @param {*} values 
     * @returns 
     */
    const checkValues = (values) => {
        const { coordenadasX, coordenadasY } = values

        let coordenada1 = Number(coordenadasX);
        let coordenada2 = Number(coordenadasY);

        if ((Number.isNaN(coordenada1)) || (Number.isNaN(coordenada2)) || (coordenadasX == "") || (coordenadasY == "")) {
            setShowAlert(true)
            return false
        }
        return true
    }

    /**
     * La función reinicia el buscador por coordenadas.
     */
    const onReset = () => {
        form.resetFields();
        setTipoCoordenadas("WGS84 H30");
        setCoordenadas("")
    };

    /**
     * Función que recibe los valores de los inputs y el select.
     * Si el sistema de coordenadas es WGS84 fija las coordenadas recibidas.
     * Si es ETRS89 o ED50, primero define un punto espacial que representa las coordenadas y después se hace la conversión a WGS84
     * 
     * @param {*} values 
     */
    const onFinish = (values) => {

        if (!checkValues(values))
            return

        const { tipoCoordenadas, coordenadasX, coordenadasY } = values

        switch (tipoCoordenadas) {
            case "WGS84":
                setCoordenadas(coordenadasX + "," + coordenadasY)
                break;
            case "ETRS89 H30":

                // Define el punto en coordenadas ETRS89 Zone 30
                const etrs89PointH30 = new Point({
                    x: coordenadasX,
                    y: coordenadasY,
                    spatialReference: { wkid: 25830 } // ETRS89 Zone 30 WKID
                });
                convertToWGS84(etrs89PointH30).then(
                    (coordenadas) => {
                        setCoordenadas(coordenadas)
                    }
                )

                break;
             case "ETRS89 H31":

                // Define el punto en coordenadas ETRS89 Zone 30
                const etrs89PointH31 = new Point({
                    x: coordenadasX,
                    y: coordenadasY,
                    spatialReference: { wkid: 25831 } // ETRS89 Zone 30 WKID
                });
                convertToWGS84(etrs89PointH31).then(
                    (coordenadas) => {
                        setCoordenadas(coordenadas)
                    }
                )

                break;
            case "ED50 H30":

                // Define el punto en coordenadas ED50 Zone 30
                const ed50PointH30 = new Point({
                    x: coordenadasX,
                    y: coordenadasY,
                    spatialReference: { wkid: 23030 } // ED50 Zone 30 WKID
                });
                convertToWGS84(ed50PointH30).then(
                    (coordenadas) => {
                        setCoordenadas(coordenadas)
                    }
                )

                break;
            case "ED50 H31":

                // Define el punto en coordenadas ED50 Zone 30
                const ed50PointH31 = new Point({
                    x: coordenadasX,
                    y: coordenadasY,
                    spatialReference: { wkid: 23030 } // ED50 Zone 30 WKID
                });
                convertToWGS84(ed50PointH31).then(
                    (coordenadas) => {
                        setCoordenadas(coordenadas)
                    }
                )

                break;
            default:
                setCoordenadas("")
                break;
        }
    };

    /**
     * Esta función fija las coordenadas que se van a buscar. La condición depende del sistema de coordenadas que se usa. 
     */
    const onCoordenadasChange = (value) => {
        switch (value) {
            case "WGS84 H3":
                form.setFieldsValue({ coordenadasX: "", coordenadasY: "" });
                setTipoCoordenadas("WGS84");
                break;
            case "ETRS89 H30":
                form.setFieldsValue({ coordenadasX: "", coordenadasY: "" });
                setTipoCoordenadas("ETRS89 H30");
                break;
            case "ED50 H30":
                form.setFieldsValue({ coordenadasX: "", coordenadasY: "" });
                setTipoCoordenadas("ED50 H30");
                break;
             case "ETRS89 H31":
                form.setFieldsValue({ coordenadasX: "", coordenadasY: "" });
                setTipoCoordenadas("ETRS89 H31");
                break;
            case "ED50 H31":
                form.setFieldsValue({ coordenadasX: "", coordenadasY: "" });
                setTipoCoordenadas("ED50 H31");
                break;
            default:
        }
    };

    /**
     * Esta función convierte coordenadas al sistema WGS84
     * Primero se define la referencia espacial de salida (WGS 84), segundo se define el URL del geometry service de esri,
     * tercero se crean los parametros para realizar la transformación y por último se realiza la conversión.
     * 
     * @param {*} point 
     * @returns 
     */
    const convertToWGS84 = async (point) => {

        let coordenadas = "";
        const wgs84SpatialReference = { wkid: 4326 }; // WGS 84 WKID
        const geometryServiceUrl = "https://utility.arcgisonline.com/ArcGIS/rest/services/Geometry/GeometryServer";

        const params = new ProjectParameters({
            geometries: [point],
            outSpatialReference: wgs84SpatialReference
        });

        await project(geometryServiceUrl, params)
            .then(result => {
                const wgs84Point = result[0].toJSON();
                //console.log("Original Coordinates:", point.toJSON());
                //console.log("WGS 84 Coordinates:", wgs84Point);
                coordenadas = (wgs84Point.x).toString() + "," + (wgs84Point.y).toString()
                console.log("coordenadas 1", coordenadas)
            })
            .catch(error => {
                console.error("Error:", error);
            });
        return coordenadas
    }

    return (
        <>
            <Form
                {...formItemLayout}
                layout={"vertical"}
                form={form}
                onFinish={onFinish}
                initialValues={{ layout: "vertical" }}
                style={{ maxWidth: 600 }}
            >
                <Form.Item
                    name="coordenadasX"
                    label={tipoCoordenadas === "WGS84" ? "Longitud" : "X"}
                >
                    <Input style={{ width: "300px" }} />
                </Form.Item>
                <Form.Item
                    name="coordenadasY"
                    label={tipoCoordenadas === "WGS84" ? "Latitud" : "Y"}
                >
                    <Input style={{ width: "300px" }} />
                </Form.Item>

                <Form.Item
                    name="tipoCoordenadas"
                    label="Coordenadas"
                    rules={[{ required: true }]}
                >
                    <Select
                        placeholder="Selecciona sistema de coordenadas"
                        onChange={onCoordenadasChange}
                        allowClear
                        style={{ width: "300px" }}
                    >
                        <Option value="WGS84">{i18next.t('common.tools.search_coordinates.coordinates.WGS84')}</Option>
                        <Option value="ETRS89 H30">{"ETRS89 H30"}</Option>
                        <Option value="ETRS89 H31">{"ETRS89 H31"}</Option>
                        <Option value="ED50 H30">{"ED50 H30"}</Option>
                        <Option value="ED50 H31">{"ED50 H31"}</Option>
                    </Select>
                </Form.Item>

                <Form.Item {...buttonItemLayout}>
                    <Space>
                        <Button type="primary" htmlType="submit">
                            Aceptar
                        </Button>
                        <Button htmlType="button" onClick={onReset}>
                            Resetear
                        </Button>
                    </Space>
                </Form.Item>
            </Form>
            {
                showAlert && <Space>
                    <Alert
                        message={i18next.t('common.tools.search_coordinates.error_message')}
                        type="error"
                        closable
                        onClose={() => setShowAlert(false)}
                    />
                </Space>
            }

        </>

    )

}

export default SearchCoordinatesComponent;